import React from 'react';
import Tags from '@/components/Atomics/Tags/tags';
import { usePermissions } from '@/util/hooks/checkPermissions';

interface ProductTagsProps {
  show48h?: boolean;
  showCrossBorder?: boolean;
  showJzd?: boolean;
}

const ProductTags: React.FC<ProductTagsProps> = ({ show48h, showCrossBorder, showJzd }) => {
  const { checkPermission } = usePermissions();
  const show48HConfig = checkPermission('show48H');
  const display48H = show48HConfig && show48h;

  if (!display48H && !showCrossBorder && !showJzd) {
    return null;
  }

  return (
    <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
      {display48H && (
        <span style={{ marginRight: '5px' }}>
          <Tags type='48h' />
        </span>
      )}
      {!display48H && showJzd && (
        <span style={{ marginRight: '5px' }}>
          <Tags type='jzd' />
        </span>
      )}
      {!display48H && !showJzd && showCrossBorder && (
        <span style={{ marginRight: '5px' }}>
          <Tags type='cross' />
        </span>
      )}
    </div>
  );
};

export default ProductTags; 